module.exports = __webpack_public_path__ + "img/parcoursup-2025.fb04d1e.png";